// @ts-nocheck
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useChart } from '../chart';
import { fNumber } from '../../utils/formatNumber';

interface TokensByProjectPieProps {
  title: string;
  subheader?: string;
  chartData: { label: string; value: number }[];
  chartColors?: string[];
}

export default function TokensByProjectPie({ title, subheader, chartData, chartColors }: TokensByProjectPieProps) {
  const theme = useTheme();

  const chartLabels = chartData.map((i) => i.label);
  const chartSeries = chartData.map((i) => i.value);

  const chartOptions = useChart({
    colors: chartColors,
    labels: chartLabels,
    stroke: { width: 2, colors: [theme.palette.background.paper] },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      itemMargin: { horizontal: 8, vertical: 4 },
      floating: false,
    },
    dataLabels: {
      enabled: true,
      dropShadow: { enabled: false },
      formatter: (val) => `${val.toFixed(1)}%`,
      style: { fontSize: '11px', fontWeight: 600, colors: ['#fff'] },
    },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (val) => fNumber(val) + ' tokens',
        title: { formatter: (seriesName) => `${seriesName}` },
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        donut: { labels: { show: false } },
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: { height: 300 },
          legend: { fontSize: '11px' },
        },
      },
    ],
  });

  return (
    <Card>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 2, pb: 1 }} dir="ltr">
        <ReactApexChart type="pie" series={chartSeries} options={chartOptions} height={420} />
      </Box>
    </Card>
  );
}
